import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store';

@Component({
  selector: 'app-expired-report',
  templateUrl: './expired-report.component.html',
  styleUrls: ['./expired-report.component.css']
})
export class ExpiredReportComponent extends ReportBase implements OnInit {

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/expired-report/expired-report.component.ts